import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.16);

  background: white;

  .content {
    margin: 0 auto;
  }
`;

export const GradientBackground = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 100px;
  z-index: -1;
  background: #e84e22;
  background: linear-gradient(
    0deg,
    var(--green2c) -60%,
    rgba(248, 251, 246, 1) 70%,
    rgba(255, 255, 255, 1) 80%
  );
`;

export const Menu = styled.menu`
  > ul {
    display: flex;
    /* justify-content: space-between; */
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;

    > li {
      font-family: 'Montserrat';
      font-weight: bold;
      font-size: 1rem;
      color: #000;
      list-style: none;
      cursor: pointer;
    }
  }
`;

export const Logo = styled.img`
  display: block;
  margin: 15px auto;
  cursor: pointer;

  width: 10rem;
  height: auto;

  @media (max-width: 640px) {
    margin-top: 40px;
  }

  @media (max-width: 560px) {
    width: 12rem;
    height: auto;
  }
`;

export const CopyRight = styled.span`
  position: absolute;
  bottom: 10px;
  right: 20px;
  font-family: 'Montserrat';
  font-size: 1rem;
  color: grey;

  @media (max-width: 1080px) {
    left: 50%;
    transform: translateX(-50%);
    right: auto;
  }
`;
